(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-dnh-contact-files]').forEach((input) => {
    if (input.dataset.ready === 'true') return;
    input.dataset.ready = 'true';

    const form = input.closest('.dnh-contact-form__form');
    const list = form?.querySelector('[data-dnh-contact-file-list]');
    const hiddenInput = form?.querySelector('[data-dnh-contact-file-names]');
    const maximumFiles = 10;
    const maximumFileSize = 10 * 1024 * 1024;

    input.addEventListener('change', () => {
      const files = Array.from(input.files || []);
      const invalidCount = files.length > maximumFiles;
      const oversizedFile = files.find((file) => file.size > maximumFileSize);

      if (invalidCount || oversizedFile) {
        input.value = '';
        if (hiddenInput) hiddenInput.value = '';
        if (list) {
          list.hidden = false;
          list.textContent = invalidCount
            ? 'You can attach up to 10 files.'
            : 'Each file must be 10 MB or smaller.';
          list.classList.add('is-error');
        }
        return;
      }

      const fileNames = files.map((file) => file.name);
      if (hiddenInput) hiddenInput.value = fileNames.join(', ');
      if (list) {
        list.classList.remove('is-error');
        list.textContent = fileNames.join(', ');
        list.hidden = fileNames.length === 0;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
